import { AfterViewChecked, Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AppConfig } from 'app/app.config';
import { ConfigService, SystemConfigurationModel } from 'app/shared/services/configService';

@Component({
  selector: 'app-system-configuration',
  templateUrl: './system-configuration.component.html',
  styleUrls: ['./system-configuration.component.css']
})
export class SystemConfigurationComponent implements OnInit {
  public configModel: SystemConfigurationModel;

  constructor(
    private configService: ConfigService,
    private config: AppConfig,
    private snackBar: MatSnackBar) { }

  ngOnInit(): void {
    this.configService.GetSystemConfigurations().then((configs) => {
      this.configModel = configs
    });
  }

  saveConfig(): void {
    this.configService.SaveSystemConfigurations(this.configModel).then(res => {
      this.snackBar.open("Configurations Saved.", 'close',  {duration: 3000});
    });
  }
}
